<template>
  <a-modal v-model:visible="visible" title="支付宝扫码授权" :maskClosable="false" :closable="false">
     <div class="box" v-if="params.QrCodeUrl">
      <div>
        <span class='tip'>
          支付宝应用AppID【{{ params.userData?.userName }}】
        </span><br>
      </div>
      <vue-qr :size="260" :text="params.QrCodeUrl" />
      <div style="text-align: left;">
        <span class='tip'>
          如已确认完成扫码授权，请点击【已确认完成授权】按钮 <br>
          如未授权成功，则无使用铺货代发等功能
        </span>
      </div>
    </div>
    <template #footer>
      <a-button type="primary" :loading="loading" @click="finishAuth">已确认完成授权</a-button>
    </template>  
  </a-modal>
</template>
<script>
import VueQr from 'vue-qr/src/packages/vue-qr.vue'
import api from '../login_modal/api'
export default {
  components: { VueQr },
  data() {
    return {
      visible: false,
      loading: false,
      params: {}
    }
  },
  methods: {
    show(data) {
      this.visible = true
      this.params = data
      this.loading = false
    },
    async finishAuth() {
      this.loading = true
      const { success, msg, result } = await api.Login(this.params.userData)
      this.loading = false
      // 登录成功
      if (success && result?.Token) {
        this.$message.success('扫码授权成功，登录成功')
        this.visible = false
        this.$emit('change', result)
      }
      // 注册 (扫码授权)
      else if (!success && result?.QrCodeUrl) {
        this.$message.warn('检测到还未扫码授权成功，请继续扫码完成授权')
        this.params.QrCodeUrl = result?.QrCodeUrl
      }
      // 返回错误信息
      else if (msg) this.$message.warning(`扫码授权失败，原因:【${msg}】`)
    }
  }
}
</script>
<style scoped lang='less'>
  .box {
    font-size: 16px;
    text-align: center;
  }
</style>